import { WEB_CASH_CHANGE_ACTIVE_PAGE } from '../actionConstants/cashConstants';

export const cashChangeActivePage = ({ activePage }) => ({
  type: WEB_CASH_CHANGE_ACTIVE_PAGE,
  payload: { activePage },
});
